import {
  BIOCLOCK_STORE_KEY,
  INTERVAL_DAY,
  PHYSIC_CYCLE,
  EMOTION_CYCLE,
  INTELLECTUAL_CYCLE,
} from './constants';
import moment from 'moment';
import BigNumber from 'bignumber.js';

function setItem(items) {
  localStorage.setItem(BIOCLOCK_STORE_KEY, items);
}

function getItem() {
  return localStorage.getItem(BIOCLOCK_STORE_KEY);
}

/**
 * 生物钟计算公式: 总天数X＝365×A＋A÷4±B
 * A——计算年份与出生年份之差；
 * B——本年生日到计算日的总天数；
 * A/4   ——  A年之中具有的闰年数（用整数表示）；
 * 加减号的运用要求：如没到生日，B前为“—”，已过生日，B前为“+”。
 *
 * X＝365×（1987－1962）＋（1987－1962）÷4＋（12＋31＋30＋20）＝8859（天）
 *
 * */

function calculateDays(startDate, endDate, errCallback = () => {}) {
  // 出生日期
  const start = moment(startDate);

  // 计算日期
  const end = moment(endDate);

  // 年份差值
  const diffYear = end.diff(start, 'years');

  // 计算日期在出生日期之前，则报错
  if (diffYear < 0) {
    errCallback({
      code: '',
      message: '查询日期不能早于出生日期！',
    });
  }

  const birthDayNewYear = moment().year(start.year()).month(0).date(1);
  const birthDiffDays = start.diff(birthDayNewYear, 'days');

  const endDayNewYear = moment().year(end.year()).month(0).date(1);
  const endDiffDays = end.diff(endDayNewYear, 'days');

  // 出生日期到计算日期的总天数
  const totalDays =
    365 * diffYear + Math.ceil(diffYear / 4) + endDiffDays - birthDiffDays;

  return totalDays;
}

// 计算天数优化
function calculateDaysOp(startDate, endDate, errCallback = () => {}) {
  // 出生日期
  const start = moment(startDate);

  // 计算日期
  const end = moment(endDate);

  const days = end.diff(start, 'days');

  return days;
}

/**
 *
 * @param {number} days
 */
function getPSIAndDate(days) {
  const physical = getPhysical(days);
  const sensitive = getSensitive(days);
  const intellectual = getIntellectual(days);

  return {
    physical,
    sensitive,
    intellectual,
  };
}

// 获取特定日期前后特定天数的日期列表
function getRecentDates(date) {
  const current = moment(date);
  const addCopy = moment(date);
  const subCopy = moment(date);
  const dateList = [current.format('YYYY-MM-DD')];

  for (let i = 0; i < INTERVAL_DAY; i++) {
    dateList.push(addCopy.add(1, 'days').format('YYYY-MM-DD'));
    dateList.unshift(subCopy.subtract(1, 'days').format('YYYY-MM-DD'));
  }

  return dateList;
}

// 获取特定天数日期的各项数据和日期
function getEchartsData(dateList, birthDay) {
  const xAxisDate = [];
  const pData = []; // 体力曲线数据
  const sData = []; // 情绪曲线数据
  const iData = []; // 智力曲线数据
  for (let date of dateList) {
    const days = calculateDaysOp(birthDay, date);
    const { physical, sensitive, intellectual } = getPSIAndDate(days);
    xAxisDate.push(date);
    pData.push(physical);
    sData.push(sensitive);
    iData.push(intellectual);
  }

  return {
    xAxisDate,
    pData,
    sData,
    iData,
  };
}

// 获取体力值
function getPhysical(days) {
  if (!days || typeof days !== 'number') return 0;

  const pBigNum = new BigNumber(days);
  const pData = pBigNum
    .multipliedBy(Math.PI)
    .multipliedBy(2)
    .dividedBy(PHYSIC_CYCLE);

  const pValue = Math.round(Math.sin(pData.toNumber()) * 100);

  return pValue;
}

// 获取情绪值
function getSensitive(days) {
  if (!days || typeof days !== 'number') return 0;

  const sBigNum = new BigNumber(days);
  const sData = sBigNum
    .multipliedBy(Math.PI)
    .multipliedBy(2)
    .dividedBy(EMOTION_CYCLE);
  const sValue = Math.round(Math.sin(sData.toNumber()) * 100);

  return sValue;
}

// 获取智力值
function getIntellectual(days) {
  if (!days || typeof days !== 'number') return 0;

  const iBigNum = new BigNumber(days);
  const iData = iBigNum
    .multipliedBy(Math.PI)
    .multipliedBy(2)
    .dividedBy(INTELLECTUAL_CYCLE);
  const iValue = Math.round(Math.sin(iData.toNumber()) * 100);

  return iValue;
}

export {
  setItem,
  getItem,
  calculateDays,
  getPSIAndDate,
  getRecentDates,
  getEchartsData,
  calculateDaysOp,
};
